import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";
import RouterModel from "../../router/RouterModel.js";

import PlosEx from "./Export/PlosEx.vue";
import PlosP from "./Print/PlosP.vue";
import PlosR from "./Report/PlosR.vue";

export default {
  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.ProfitLoss, AppModuleType.Export),
        name: RouterModel.getName(AppModule.ProfitLoss, AppModuleType.Export),
        component: PlosEx,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.ProfitLoss, AppModuleType.Export),
          module: RouterModel.getModule(AppModule.ProfitLoss),
          moduleattr: AppModuleAttr.ProfitLoss_Act_Export,
          moduletype: AppModuleType.Export
        }
      },
      {
        path: RouterModel.getPath(AppModule.ProfitLoss),
        name: RouterModel.getName(AppModule.ProfitLoss),
        component: PlosR,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.ProfitLoss),
          module: RouterModel.getModule(AppModule.ProfitLoss),
          moduleattr: AppModuleAttr.ProfitLoss_Act_Report,
          moduletype: AppModuleType.Report,
          // actions
          export: {
            module: RouterModel.getModule(AppModule.ProfitLoss),
            moduleattr: AppModuleAttr.ProfitLoss_Act_Export,
            moduletype: AppModuleType.Export
          },
          print: {
            module: RouterModel.getModule(AppModule.ProfitLoss),
            moduleattr: AppModuleAttr.ProfitLoss_Act_Print,
            moduletype: AppModuleType.Print
          }
        }
      }
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.ProfitLoss, AppModuleType.Print),
        name: RouterModel.getName(AppModule.ProfitLoss, AppModuleType.Print),
        component: PlosP,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.ProfitLoss, AppModuleType.Print),
          module: RouterModel.getModule(AppModule.ProfitLoss),
          moduleattr: AppModuleAttr.ProfitLoss_Act_Print,
          moduletype: AppModuleType.Print
        }
      }
    ];
  }
}